import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@material-ui/core';
import useStyles from './DateRangePicker.styled';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import { useSelector } from 'react-redux';
import 'react-dates/initialize';
import moment from 'moment';

const RangePicker = ({
  label,
  endDate,
  startDate,
  onDatesChange,
  onClose,
  showClearDates,
  disabled,
}) => {
  const classes = useStyles();
  const [focusedInput, setFocusedInput] = useState(null);
  const { localeFormat } = useSelector((state) => state.organizations);

  /**
   * Handle date range picker focus
   */
  const onFocusChange = (focusedInput) => setFocusedInput(focusedInput);

  /**
   * Render day content
   * @param {*} date
   */
  const renderDayContents = (date) => (
    <span
      className={date.format(localeFormat) === moment().format(localeFormat) ? classes.isToday : ''}
    >
      {date.format('D')}
    </span>
  );

  return (
    <Box display="flex" data-cy="date-range" flexDirection="column" className={classes.container}>
      {label && (
        <Typography variant="body2" component="span" color="textPrimary" className={classes.label}>
          {label}
        </Typography>
      )}
      <DateRangePicker
        small={true}
        daySize={30}
        endDate={endDate}
        onClose={onClose}
        startDate={startDate}
        enableOutsideDays={true}
        showDefaultInputIcon={true}
        focusedInput={focusedInput}
        isOutsideRange={() => false}
        onDatesChange={onDatesChange}
        onFocusChange={onFocusChange}
        endDateId="calendar_end_date"
        showClearDates={showClearDates}
        startDateId="calendar_start_date"
        hideKeyboardShortcutsPanel={true}
        renderDayContents={renderDayContents}
        disabled={disabled}
      />
    </Box>
  );
};

RangePicker.propTypes = {
  endDate: PropTypes.any,
  startDate: PropTypes.any,
  showClearDates: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onDatesChange: PropTypes.func.isRequired,
};

RangePicker.defaultProps = {
  onClose: () => {},
  showClearDates: false,
  onDatesChange: () => {},
};

export default RangePicker;
